import { CommonModule } from '@angular/common';
import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ChangeDetectionStrategy
} from '@angular/core';
import { OpportunityEstimateSummaryView, OpportunityEstimateView } from '@api-proxies';
import { EstimateService } from '@http/clients/estimate.service';
import { CustomPercentagePipe } from '@pipes/custom-percentage.pipe';
import { AwaiterService } from '@services/awaiter.service';
import { SectionHeaderComponent } from '@shared/section-header/section-header.component';
import { BadgeComponent, ExternalLinkComponent, GridViewComponent } from 'ngx-lib';

@Component({
    selector: 'app-estimates-summary',
    templateUrl: './estimates-summary.component.html',
    styleUrls: ['./estimates-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        SectionHeaderComponent,
        BadgeComponent,
        ExternalLinkComponent,
        GridViewComponent,
        CustomPercentagePipe
    ]
})
export class EstimatesSummaryComponent implements OnChanges {
    finalEstimate?: OpportunityEstimateView;

    baseEstimate?: OpportunityEstimateView[];

    alternateEstimates?: OpportunityEstimateView[];

    estimateSummaries?: OpportunityEstimateSummaryView[];

    @Input()
    estimateId?: number;

    @Output()
    goBackClicked: EventEmitter<boolean>;

    constructor(
        private readonly estimateService: EstimateService,
        private readonly awaiter: AwaiterService
    ) {
        this.baseEstimate = [];
        this.alternateEstimates = [];
        this.estimateId = 0;
        this.goBackClicked = new EventEmitter<boolean>();
    }

    async ngOnChanges(changes: SimpleChanges): Promise<void> {
        if (changes['estimateId']) {
            await this.awaiter.awaitAction('Loading Final Estimate Overview', async () => {
                if (!this.estimateId) return;
                this.finalEstimate = await this.estimateService.getFinalEstimateOverview(this.estimateId);

                const { alternateEstimateViews, baseEstimateView, opportunityEstimateSummaries } = this.finalEstimate;

                this.baseEstimate = [baseEstimateView];
                this.alternateEstimates = alternateEstimateViews;
                this.estimateSummaries = opportunityEstimateSummaries;
            });
        }
    }

    onRowClicked(opportunityEstimate: OpportunityEstimateView) {
        window.open(opportunityEstimate?.externalUrl, '_blank');
    }

    onGoBackClicked() {
        this.goBackClicked.emit();
    }
}
